import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"

import {
  createStockTransferRequest,
  editStockTransferRequest
} from "services"
import { Button } from "components"
import classes from "./StrmrmFooter.module.scss"
import { ObjectValues } from "utils"

const StrmrmFooter = (props) => {
  const {
    editMode,
    sourceBranchId,
    requestedItems,
    setOpenMakeRequestModal,
    setStockTransferRequests,
    stockTransferRequestForEdit
  } = props

  const destinationBranchId =
    useSelector(state => state.userAccountInfo.branchId)

  const systemBranches =
    useSelector(state => state.systemBranches)

  const [sending, setSending] = useState(false)

  const unmount = useRef(false)

  const getRequestBody = () => {
    const requestedItemsArray =
      ObjectValues(requestedItems)

    const newRequestedItems = []

    requestedItemsArray.forEach(requestedItem => {
      if (
        !requestedItem.requestedQuantity ||
        requestedItem.requestedQuantity === 0
      ) return

      newRequestedItems.push({
        ...requestedItem,
        requestedQuantity: Number(requestedItem.requestedQuantity)
      })
    })

    return {
      sourceBranchId,
      destinationBranchId,
      requestedItems: newRequestedItems
    }
  }

  const handleEditStockTransferRequest = async () => {
    const data = getRequestBody()

    if (data.requestedItems.length === 0) {
      return toast.error("حداقل یک کالا برای درخواست الزامی است")
    }

    setSending(true)

    try {
      const response =
        await editStockTransferRequest(
          stockTransferRequestForEdit._id,
          data
        )

      if (unmount.current) return

      const sourceBranch =
        systemBranches.find(systemBranch =>
          systemBranch._id === sourceBranchId
        )

      const destinationBranch =
        systemBranches.find(systemBranch =>
          systemBranch._id === sourceBranchId
        )

      const editedStockTransferRequest = {
        ...response,
        sourceBranch: {
          _id: sourceBranch._id,
          name: sourceBranch.name,
          address: sourceBranch.address
        },
        destinationBranch: {
          _id: destinationBranch._id,
          name: destinationBranch.name,
          address: destinationBranch.address
        }
      }

      setStockTransferRequests(prev =>
        prev.map(str =>
          str._id === stockTransferRequestForEdit._id
            ? editedStockTransferRequest
            : str
        )
      )

      setOpenMakeRequestModal(false)

      toast.success("درخواست ویرایش شد")
    } catch (err) {
      console.log(err)

      toast.error("درخواست ویرایش نشد")

      setSending(false)
    }
  }

  const handleSendStockTransferRequest = async () => {
    const data = getRequestBody()

    if (data.requestedItems.length === 0) {
      return toast.error("حداقل یک کالا برای درخواست الزامی است")
    }

    setSending(true)

    try {
      const response =
        await createStockTransferRequest(data)

      if (unmount.current) return

      const sourceBranch =
        systemBranches.find(systemBranch =>
          systemBranch._id === sourceBranchId
        )

      const destinationBranch =
        systemBranches.find(systemBranch =>
          systemBranch._id === sourceBranchId
        )

      const newStockTransferRequest = {
        ...response,
        sourceBranch: {
          _id: sourceBranch._id,
          name: sourceBranch.name,
          address: sourceBranch.address
        },
        destinationBranch: {
          _id: destinationBranch._id,
          name: destinationBranch.name,
          address: destinationBranch.address
        }
      }

      setStockTransferRequests(prev =>
        [newStockTransferRequest, ...prev]
      )

      setOpenMakeRequestModal(false)

      toast.success("درخواست ارسال شد")
    } catch (err) {
      console.log(err)

      toast.error("درخواست ارسال نشد")

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <div className={classes["footer"]}>
      {editMode
        ?
        <Button
          loading={sending}
          onClick={handleEditStockTransferRequest}
          color="success"
        >
          ویرایش درخواست
        </Button>
        :
        <Button
          loading={sending}
          onClick={handleSendStockTransferRequest}
          color="success"
        >
          ارسال درخواست
        </Button>
      }
    </div>
  )
}

export default StrmrmFooter